import React from 'react';
import {Card, Row, Col, Modal} from 'antd';
import * as etiquetas from '../../ApplicationResources';
import InputText from '../interfaz/InputText';
import Select, {Option} from '../interfaz/Select';
import errorImgModal from '../../img/error_icon.svg';

class DatosEscolaridad extends React.Component {

    constructor(props) {
        super(props);
        // Setting the initial state
        this.state = {
            lstEscolaridades : null,
            carreraRequired : false,
            msjError : "",
            abrirModalError : false
        };

    }

    cerrarErrorModal(){
      this.setState({abrirModalError:false});
    }

    componentWillMount() {
        // Obtenemos la lista de escolaridades previamente cargada
        var listaEscolaridades = this.props.objetos[etiquetas.WIZARD_DATOS_ESCOLARIDAD].lstEscolaridades
        // Eliminamos la escolaridad con id 20=Carrera
        var auxListaEscolaridades = listaEscolaridades.filter( item => parseInt(item.idEscolaridad) !== 20 );

        // Asignamos al estate la lista de escolaridades filtrada
        this.setState({
            lstEscolaridades: auxListaEscolaridades
        });
    }

    handleEscolaridadChange = (idEscolaridad) => {
        if (idEscolaridad < etiquetas.ID_PRIMERO_BACHILLERATO)
            this.props.form.setFieldsValue({ 'carrera': undefined });
    }

    render() {
        return(
           <React.Fragment>
              <>
                <Card title={etiquetas.datos_escolaridad_lbl_titulo} bordered={false}>
                    <Row >
                        <Col sm={24} md={24} lg={24}>
                            <Select nombre='idEscolaridad'
                                    placeholder={etiquetas.datos_escolaridad_lbl_escolaridad}
                                    onChange={this.handleEscolaridadChange}
                                    form={this.props.form}
                                    required={true}
                                    msjRequerido={etiquetas.general_dato_requerido}
                                    rules={[{type: 'number'}]}
                                    showSearch={true}>
                                        {
                                            this.state.lstEscolaridades &&
                                            this.state.lstEscolaridades.map((escolaridad, index) => (
                                                <Option key={index} value={escolaridad.idEscolaridad}>{escolaridad.descripcion}</Option>
                                            ))
                                        }
                            </Select>
                        </Col>
                    </Row>
                    <Row >
                        <Col sm={24} md={24} lg={24}>
                            <InputText nombre="carrera"
                                       placeholder={etiquetas.datos_escolaridad_lbl_carrera}
                                       form={this.props.form}
                                       required={this.state.carreraRequired}
                                       msjRequerido={etiquetas.general_dato_requerido}
                                       maxLength={50}
                                       rules={[{
                                                max: 50
                                                , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                            }]}
                                       disabled={(this.props.form.getFieldValue("idEscolaridad") < etiquetas.ID_PRIMERO_BACHILLERATO)} />
                        </Col>
                    </Row>
                    <Row gutter={8}>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="estudioActual"
                                       placeholder={etiquetas.datos_escolaridad_lbl_estudioActual}
                                       form={this.props.form}
                                       required={this.props.form.getFieldValue("institucion")}
                                       msjRequerido={etiquetas.general_dato_requerido}
                                       maxLength={50}
                                       rules={[{
                                                max: 50
                                                , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                            }]}/>
                        </Col>
                        <Col sm={24} md={12} lg={12}>
                            <InputText nombre="institucion"
                                       placeholder={etiquetas.datos_escolaridad_lbl_institucion}
                                       form={this.props.form}
                                       required={this.props.form.getFieldValue("estudioActual")}
                                       msjRequerido={etiquetas.general_dato_requerido}
                                       maxLength={50}
                                       rules={[{
                                                max: 50
                                                , pattern: etiquetas.REGEX_FORMATO_NO_CARACTERES_ESPECIALES
                                            }]}
                                        disabled={!this.props.form.getFieldValue("estudioActual")} />
                        </Col>
                    </Row>
                </Card>
                <Modal
                  className="modalError"
                  title={<img  src={errorImgModal} id="img-error-modal"/>}
                  centered
                  onCancel={()=>this.cerrarErrorModal()}
                  visible={this.state.abrirModalError}
                  footer={false}
                  width={400}
                >
                  {this.state.msjError}
                </Modal>
                </>
           </React.Fragment>
        );
    }
};

export default DatosEscolaridad;
